import dayjs from 'dayjs'

export default{
    formatDateTime(dateTime, isShort) {
        if (isShort) {
            return dayjs(dateTime).format('D/M/YYYY - HH:mm')
        }

        return dayjs(dateTime).format('D MMMM YYYY - HH:mm')
    }
}
